import React from 'react';
import {
  ChakraProvider,
} from '@chakra-ui/react';
import Content from './Pages/Content';
import theme from './CustomTheme'; 

// MSAL imports
import { MsalProvider } from "@azure/msal-react";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PropertyCertificates from './Pages/PropertyCertificates';
import WasteServices from './Pages/WasteServices';
import Debtors from './Pages/Debtors';
import Rates from './Pages/Rates';
import BinCollection from './Pages/BinCollection';
import DebtorsPaid from './Pages/DebtorsPaid';
import RatesPaid from './Pages/RatesPaid';
import WasteServicesPaid from './Pages/WasteServicesPaid';
import PropertyCertificatesPaid from './Pages/PropertyCertificatesPaid';
import MaitlandPool from './Pages/MaitlandPool';
import EastMaitlandPool from './Pages/EastMaitlandPool';

// Main component housing all sub components
// We wil be using Chakra-UI as a component based theme.
function Main({ pca }) {
  return (
    <MsalProvider instance={pca}>
      <ChakraProvider theme={theme}>     
        <Router>
          <Routes>
            <Route path="/" element={<Content />} />  
            <Route path="propertycertificates" element={<PropertyCertificates />} />    
            <Route path="wasteServices" element={<WasteServices />} />    
            <Route path="debtors" element={<Debtors />} />    
            <Route path="rates" element={<Rates />} />    
            <Route path="bincollection" element={<BinCollection />} /> 
            <Route path="debtorspaid" element={<DebtorsPaid />} />  
            <Route path="ratespaid" element={<RatesPaid />} />  
            <Route path="wasteservicespaid" element={<WasteServicesPaid />} />  
            <Route path="propertycertificatespaid" element={<PropertyCertificatesPaid />} />
            <Route path="maitland-pool" element={<MaitlandPool />} />
            <Route path="east-maitland-pool" element={<EastMaitlandPool />} />
          </Routes>
        </Router>
      </ChakraProvider>
    </MsalProvider>
  );
}

export default Main;